import { useTranslation } from 'react-i18next';

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';

import earth from '../../images/earth.png';

const languageLabels = {
    english: 'English',
    chinese: '中文',
    japanese: '日本語',
};

const menuProps = {
    PaperProps: {
        sx: {
            mt: 1,
            px: 1,
            py: 0.5,
            borderRadius: '8px',
            boxShadow: '0 16px 35px rgba(39, 99, 234, 0.18)',
            '& .MuiMenuItem-root': {
                borderRadius: '4px',
                fontSize: 14,
                fontWeight: 500,
                px: 2,
                py: 1,
            },
            '& .MuiMenuItem-root.Mui-selected': {
                backgroundColor: 'rgba(76, 128, 255, 0.16)',
            },
            '& .MuiMenuItem-root.Mui-selected:hover': {
                backgroundColor: 'rgba(76, 128, 255, 0.22)',
            },
        },
    },
};

const LanguageControl = ({ className = '' }) => {
    const { i18n } = useTranslation();

    return (
        <div className={`flex items-center justify-center ${className}`}>
            <FormControl size='small' sx={{ m: 0 }}>
                <Select
                    value={i18n.language}
                    onChange={(event) => i18n.changeLanguage(event.target.value)}
                    IconComponent={KeyboardArrowDownIcon}
                    MenuProps={menuProps}
                    renderValue={(selected) => (
                        <Box component='span' sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <Box
                                component='img'
                                src={earth}
                                alt='Earth icon'
                                sx={{ width: 14, height: 14, opacity: 0.8 }}
                            />
                            {languageLabels[selected as keyof typeof languageLabels] || selected}
                        </Box>
                    )}
                    sx={{
                        borderRadius: '999px',
                        backgroundColor: '#ffffff',
                        // boxShadow: '0 12px 30px rgba(31, 37, 46, 0.12)',
                        '.MuiOutlinedInput-notchedOutline': { border: 'none' },
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': { border: 'none' },
                        '& .MuiSelect-select': {
                            display: 'flex',
                            alignItems: 'center',
                            gap: 8,
                            px: 2.5,
                            py: 1,
                            borderRadius: '999px',
                            fontSize: 14,
                            fontWeight: 500,
                            color: '#1F252E',
                        },
                        '& .MuiSvgIcon-root': {
                            fontSize: 20,
                            color: '#5B6472',
                            mr: 0,
                        },
                    }}
                >
                    <MenuItem value='english'>English</MenuItem>
                    <MenuItem value='chinese'>中文</MenuItem>
                    <MenuItem value='japanese'>日本語</MenuItem>
                </Select>
            </FormControl>
        </div>
    );
};

export default LanguageControl;
